import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { fetchMeRequested } from '@/features/auth/authSlice';
import { LanguageSwitcher } from '@/components/LanguageSwitcher';
import { ThemeToggle } from '@/components/ThemeToggle';
import styles from './Header.module.scss';

export const Header: React.FC = () => {
  const { t } = useTranslation('header');
  const dispatch = useAppDispatch();
  const { checked, authenticated, user } = useAppSelector((state) => state.auth);

  useEffect(() => {
    dispatch(fetchMeRequested());
  }, [dispatch]);

  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <a href="/" className={styles.brand}>
          <img
            src="/assets/logo-primary-color.svg"
            alt="Airooki"
            className={styles.logo}
          />
        </a>
        <nav className={styles.nav}>
          <a href="/#services" className={styles.navLink}>
            {t('services')}
          </a>
          <LanguageSwitcher />
          <ThemeToggle />
          {checked && (authenticated ? (
            <details className={styles.accountMenu}>
              <summary className={styles.accountTrigger} aria-label={t('accountMenu')}>
                <span className={styles.avatar} aria-hidden="true">
                  {(user?.name || user?.username || user?.email || '?').charAt(0).toUpperCase()}
                </span>
                <span className={styles.userName}>{user?.name || user?.username || user?.email}</span>
                <span className={styles.chevron} aria-hidden="true">⌄</span>
              </summary>
              <div className={styles.accountPanel}>
                <a href="/auth/account" className={styles.menuLink}>{t('manageAccount')}</a>
                <a href="/mail-clients" className={styles.menuLink}>{t('mailClients')}</a>
                <span className={styles.menuDivider} />
                <a href="/auth/logout" className={`${styles.menuLink} ${styles.signOut}`}>{t('signOut')}</a>
              </div>
            </details>
          ) : (
            <>
              <a href="/auth/login" className={styles.navLink}>
                {t('signIn')}
              </a>
              <a href="/auth/register" className={styles.navCta}>
                {t('createAccount')}
              </a>
            </>
          ))}
        </nav>
      </div>
    </header>
  );
};
